import { render, staticRenderFns } from "./NumeratoriEditComponent.vue?vue&type=template&id=25b2fd83&scoped=true"
import script from "./NumeratoriEditComponent.vue?vue&type=script&lang=js"
export * from "./NumeratoriEditComponent.vue?vue&type=script&lang=js"
import style0 from "./NumeratoriEditComponent.vue?vue&type=style&index=0&id=25b2fd83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b2fd83",
  null
  
)

export default component.exports